import { HORIZONTAL_ALIGNMENT } from 'constants/ui';

const ColumnIds = {
  YEAR: 'year',
  MONTH: 'month',
  PAYMENT: 'payment',
  DISBURSEMENT: 'disbursement',
  DESCRIPTION: 'description',
  BALANCE: 'balance',
};

export const columnsDefs = [
  {
    id: ColumnIds.YEAR,
    label: 'Year',
    style: {
      width: '10.5%',
    },
  },
  {
    id: ColumnIds.MONTH,
    label: 'Month',
    style: {
      width: '16%',
    },
  },
  {
    id: ColumnIds.PAYMENT,
    label: 'Payment',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    style: {
      width: '16%',
    },
  },
  {
    id: ColumnIds.DISBURSEMENT,
    label: 'Disbursement',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    style: {
      width: '16%',
    },
  },
  {
    id: ColumnIds.DESCRIPTION,
    label: 'Description',
    style: {
      width: '25.5%',
    },
  },
  {
    id: ColumnIds.BALANCE,
    label: 'Balance',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    style: {
      width: '16%',
    },
  },
];
